<template>
  <div class="news-all">
    <div class="title">
      <span class="time">
        12.04
        <br />2018
      </span>
      <span class="tiel">美菜网于创新颁奖盛典荣获年度最具投资价值企业奖</span>
    </div>
    <div class="mat-content">
      <div class="tet-js">
        前不久，2018亿欧创新者年会暨第四届创新奖颁奖盛典于北京国贸大酒店隆重举行，该会议以“智能产业 · 美好生活”为主题，并且宣布了22项年度创新奖评奖结果，其中有200余家企业及个人获此殊荣，其中就包括美菜网荣获2018“年度最具投资价值企业”奖项。
        <br />
        <br />
      </div>

      <p align="center">
        <img src="@/assets/images/new-img/b012_1.jpg" width="640" />
      </p>

      <div class="tet-js">
        值得注意的是，今年的评选较于去年更为严苛以及专业，创新奖评选活动自9月开启，历经75天，共计参与企业上千家。此外，在过去的三届创新奖获奖企业中，成功打造出获奖企业0死亡率，超过半数获得新一轮融资的优异成绩。
        <br />
        <br />
      </div>

      <p align="center">
        <img src="@/assets/images/new-img/b012_2.jpg" width="640" />
      </p>

      <div class="tet-js">
        在亿欧第四届创新奖颁奖盛典中，美菜网荣获2018“年度最具投资价值企业”大奖。美菜网作为中国餐饮供应链杰出服务商，其通过自主研发移动电商平台，自建仓储、物流、配送体系，创新升级了农产品供应链，一端链接田间地头，一端链接城市餐桌，实现农产品从地头到餐桌高速的流通。目前，业务覆盖全国城市约200个，累计服务过商户200万家。给很多农民和商家留下了“买菜买菜上美菜”的品牌印象。
        <br />
        <br />一方面，美菜通过这一模式，希望给餐饮商家带来“价格无忧，选择无忧，品类无忧，服务无忧”的无忧体验。让餐厅拥有稳定的供货渠道，产品售后有了保障，既大大地降低了餐饮行业的采购成本，也减少了企业的运营风险。另一方面，对于上游农民来说，他们可以利用美菜自主研发的大数据系统，一键了解农产品价格走向。美菜为他们提供了经营管理及决策服务，准确的将市场需求反馈给农民，从源头指导农民生产、建立产地标准，避免了农产品货不对市的问题，帮农民增产增收。
        <br />
        <br />同时，这一模式也给受到很多投资机构的青睐。据外媒报道，今年10月，美菜网筹集了约8亿美元资金，估值约为70亿美元，由老虎环球基金和高瓴资本领投。该公司的最新融资凸显出，尽管目前以人民币计价的融资大幅减少，在政策红利下的一些一流公司仍然能够获得超高估值。
        <br />
        <br />由此可见，美菜网的前景无限，当然美菜网作为互联网餐饮行业中的佼佼者，凭借出色的电商模式以及扶贫项目，在获得社会赞誉的同时，也承担起属于自己的社会责任，从侧面来说，也在推动着自身的进步与成长。
        <br />
        <br />
      </div>

      <!-- <div class="title-bold"><span></span>20年里的朴实无华</div> -->

      <!-- <p align="center"><img src="/assets/images/new-img/b011_1.jpeg" width="640"></p>
        <div class="tet-js" style="text-align: center">
          牛角2018新零售创新标杆奖现场
      </div>-->
    </div>
  </div>
</template>

<script>
export default {
  name: "new-a1"
};
</script>

<style lang="scss" scoped>
</style>
